import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { useTitle } from '../lib/title'

export default function Privacy() {
  useTitle('Privacy')
  return (
    <>
      <Header />
    <main className="wrap prose">
      <h1>Privacy</h1>
      <p className="lede">
        calendarfeedback.com collects meeting feedback without identifying individual respondents.
        Here is exactly what we store and for how long.
      </p>

      <h2>What we store</h2>
      <ul>
        <li>The signed-in user's email address, used to identify their meetings in the dashboard.</li>
        <li>For each meeting: iCalendar UID, end time, title, attendee count, and the resulting aggregate score.</li>
        <li>For each attendee: a one-way cryptographic hash of their email address, and the email's domain name. We do <strong>not</strong> store attendee email addresses in readable form.</li>
        <li>A per-attendee single-use feedback token, consumed when the attendee votes.</li>
      </ul>
      <p>We do <strong>not</strong> store meeting descriptions, attachments, the attendee list in readable form, or any of the meeting's actual content.</p>
      <p>We do <strong>not</strong> read your Google Calendar. Sign-in uses only your basic profile (email, name) — no calendar scope is requested. You can revoke our Google access at any time via your <a href="https://myaccount.google.com/permissions">Google account permissions page</a>.</p>

      <h2>Retention</h2>
      <ul>
        <li>Attendee hashes and tokens: 60 days after the meeting, then deleted.</li>
        <li>Meeting metadata: 30 days after the aggregate is sent, then anonymised.</li>
        <li>Unsubscribe suppression list: retained indefinitely so we continue to honour opt-outs.</li>
      </ul>

      <h2>Right to delete</h2>
      <p>
        Email <a href="mailto:privacy@calendarfeedback.com">privacy@calendarfeedback.com</a> and we will
        remove all records associated with your email address.
      </p>
    </main>
      <Footer />
    </>
  )
}
